<div class="order-transfer-inner">
  <div class="order-trans-top">
    <div class="order-trans-form">
      <h2>Order Transfer:</h2>
      <div class="row" *ngIf="isSubscriptionAccess">
        <div class="col-md-12">
          <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
            <mat-label>Non-Subscriber Email:</mat-label>
            <input matInput type="email" name="accountEmail"
                   placeholder="(Separate multiple email addresses by a semi-colon.)"
                   [(ngModel)]="accountEmail"
                   [pattern]="emailPattern"
                   (keyup)="validateEmail()"
                   email="true">
            <mat-error *ngIf="isNotValid">
              This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="order-box-outer">
      <div class="row">
        <div class="col-md-12 text-center order-box-sec">
          <div class="order-box card text-center">
            <div class="card-body">
              <h5 class="card-title">Order</h5>
              <p class="card-text">{{fromDealerOrderId}}</p>
            </div>
          </div>
          <div class="order-box card text-center">
            <div class="card-body">
              <h5 class="card-title">Order</h5>
              <p class="card-text">{{toDealer == null ? '' : (toDealer.orderId ? toDealer.orderId :'New Order')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row order-box-bottom">
        <div class="col-md-6">
          <div class="orderText fromOrder">
            <span>
              from:
            </span>
            <i class="fas fa-caret-up"></i>
          </div>
        </div>
        <div class="col-md-6">
          <div class="orderText toOrder">
            <span>
              to:
            </span>
            <i class="fas fa-caret-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="transferSec">

    <div class="row">
      <div class="col-md-12">
        <div class="tableContainer margBottom">
          <table class="matTables productTable mat-table">
            <thead>
            <th class="borderR" colspan="2" valign="top">
              <div class="leftColTransfer">
                <div class="growerInfo">
                  <h4>
                    {{fromDealer?.accountName}}, {{fromDealer?.city}} - {{fromDealer?.state}}
                  </h4>
                  <p class="accountName mediumFont">
                    {{fromDealer?.address1}}
                  </p>
                  <p class="address">
                    {{fromDealer?.city}} {{fromDealer?.state}} {{fromDealer?.zipCode}}
                  </p>
                  <p class="address">Account# : {{fromDealer?.accountNumber}}</p>
                </div>
              </div>
            </th>
            <th colspan="3">
              <div class="rgtColTransfer padding-r0 padding-l0">
                <div class="growerInfoTo">
                  <div class="row">
                    <div class="col-md-1 padding-l0 padding-r0 borderBot"><span class="toText">TO:</span> </div>
                    <div class=" col-md-11 padding-l0 material-select toGrowerSelectOuter borderBot">
                      <ng-select name="ddlToDealer"
                                 [items]="toDealerList"
                                 class="custom-select-grower grower-add-drop toGrowerInfo"
                                 [(ngModel)]="selectedDealer"
                                 [virtualScroll]="true"
                                 bindLabel="retailerName"
                                 bindValue="orderId"
                                 placeholder="Type here to find a transfer target"
                                 [loading]="accountLoading"
                                 [closeOnSelect]="true"
                                 (change)="selectToDealer($event)"
                                 [searchFn]="accountSearchFn">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <a [matTooltip]="item.isValidAccount ? '' : 'Item restricted from dealer transfer'" #tooltip="matTooltip"
                             [matTooltipPosition]="'below'" (mouseenter)="$event.stopImmediatePropagation()"
                             (mouseleave)="$event.stopImmediatePropagation()" (click)="tooltip.show()" matTooltipClass='seed-order-tooltip'>
                            <div class="dropdown-template">
                              <div class="row">
                                <div class="col-md-8">
                                  <h4 class="name" [ngOptionHighlight]="search">
                                    {{item.retailerName}}
                                  </h4>
                                  <p class="address" [ngOptionHighlight]="search">
                                    {{item.retailerAddress1}}
                                  </p>
                                  <p class="address" [ngOptionHighlight]="search">
                                    {{item.retailerCity}}, {{item.retailerState}}, {{item.retailerZipCode}}
                                  </p>
                                  <p class="grower-nos padding-t10" [ngOptionHighlight]="search">
                                    Account #:  {{item.shipToAccount}}
                                  </p>
                                </div>
                                <div class="col-md-4 orderId-detail text-right">
                                  Order:
                                  <p [ngOptionHighlight]="search">{{item.orderId}}</p>
                                </div>
                              </div>
                            </div>
                          </a>
                        </ng-template>
                        <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                          <div class="ng-option disabled">
                            No data found for "{{searchTerm}}"
                          </div>
                        </ng-template>
                        <ng-template ng-footer-tmp let-search="searchTerm">
                          <div class="custom-drop-footer">
                            <div class="row">
                              <div class="col-md-12 bold text-right padding-r25">
                                {{toDealerList.length}} Results
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="growerInfoToDetails">
                  <div class="row">
                    <div class="col-md-1">&nbsp;</div>
                    <div class="col-md-11 padding-l0">
                      <div class="growerInfo padding-0">
                        <p *ngIf="toDealer" class="accountName margin-t5">
                          {{toDealer?.retailerAddress1}}
                        </p>
                        <p *ngIf="toDealer" class="address mediumFont">
                          {{toDealer?.retailerCity}}, {{toDealer?.retailerState}}, {{toDealer?.retailerZipCode}}
                        </p>
                        <p *ngIf="toDealer" class="address mediumFont">Account# : {{toDealer?.shipToAccount}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </th>
            </thead>
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell origProductName">Product</th>
                <th class="mat-header-cell text-center modifiedUnit borderR">Remaining</th>
                <th class="mat-header-cell replacedProductName">Product</th>
                <th class="mat-header-cell text-center originalUnit">Transferable Units</th>
                <th class="mat-header-cell text-center editUnit">Units</th>
              </tr>
            </thead>
            <tbody *ngFor="let o2Order of orderFromToList">
              <tr class="mat-row">
                <td class="order-info mat-cell origProdNameContent" [ngClass]="!o2Order.isValidForRibTransfer ? 'pt-0':''">
                  <div class="unavailable-block-Sec" *ngIf="!o2Order.isValidForRibTransfer">
                    <div id="main_{{o2Order.rowId}}" class="unavailable-block-outer">
                      <div class="unavailable-block" [ngClass]="o2Order.seedNonReturnable ? 'adjustTopHeight':''">
                        <i class="icon-ico-Banned_Circle"></i>
                      </div>
                      <div class="unavail-content" id="sub_{{o2Order.rowId}}">
                        <h4>Item restricted to transfer to this dealer.</h4>
                      </div>
                    </div>
                  </div>
                  <div class="d-inline-block">
                    <p matTooltip="{{o2Order.Brand}} - {{o2Order.MarketingBrand}}" [matTooltipPosition]="'above'">{{o2Order.Brand}} - {{o2Order.MarketingBrand}}</p>
                    <p class="grower-name" matTooltip="{{o2Order.ItemDescription}}" [matTooltipPosition]="'above'">{{o2Order.ItemDescription}}</p>
                    <p *ngIf="o2Order.seedNonReturnable" class="grower-name nonReturnable">*NON-RETURNABLE</p>
                  </div>
                  
                </td>
                <td class="text-center mat-cell borderR ">
                  {{o2Order.RemainingQuantity}}
                </td>
                <td class="order-info mat-cell">
                  <p>{{o2Order.Brand}} - {{o2Order.MarketingBrand}}</p>
                  <p class="grower-name">{{o2Order.ItemDescription}}</p>
                </td>
                <td class="text-center mat-cell">
                  {{o2Order.TransferableUnits}}
                </td>
                <td class="text-center mat-cell unitData">
                  <div *ngIf="o2Order.isValidForRibTransfer">
                    <button (click)="geuValueChange('decrease',o2Order);o2Order.isSelected=true" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + o2Order.ItemNumber"> - </button>
                    <input type="text" [attr.disabled]="!toDealer ? 'disabled' : null" id="txtUnits" class="geu-txt" [(ngModel)]="o2Order.ToPrimaryQty" (focusout)="validateSelectedCount(o2Order, $event.target.value)" maxlength="5" appNumbersOnly [attr.data-testid]="'qty-' + o2Order.ItemNumber" />
                    <button (click)="geuValueChange('increase',o2Order); o2Order.isSelected=true" class="plus-minus-btn plusBtn" [attr.data-testid]="'increase-' + o2Order.ItemNumber"> + </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="o2Order && o2Order.LineErrors.errors.length > 0" id="error_{{o2Order.LineErrors.rowId}}">
                <td colspan="5">
                  <div class="inline-error">
                    <div class="row">
                      <div class="col-md-12">
                        <ol class="error-list">
                          <li *ngFor="let err of o2Order.LineErrors.errors" class="justify-content-center align-self-center">
                            {{err.error }}
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="tableTotalsSec">
    <div class="row">
      <div class="col-md-9">
        <button mat-raised-button class="btns" color="primary" [disabled]="!isTransfer || modifiedUnitCount<=0 || isNotValid==true" (click)="confirmToTransfer()">Preview Change</button>
        <a style="cursor:pointer" (click)="onCancel()">Cancel </a>
      </div>
      <div class="col-md-3 text-right count">
        Transferred Units:
        <span>
          {{modifiedUnitCount}}/{{originalUnitCount}}
        </span>
      </div>
    </div>
  </div>
</div>
